import React from "react";
import { useCommonOptionalLabel } from "../../../../common-deprecated/utils/commonLabels";
import * as Styles from "./styles/PageFinanceDisclaimerStyles";
import * as Container from "../../deprecated-styled-components/lexus/globals/Container";

const PageFinanceDisclaimer = (): JSX.Element | null => {
    const financeDisclaimerLabel = useCommonOptionalLabel("uscPageFinanceDisclaimer");

    if (!financeDisclaimerLabel) return null;

    return (
        <Container.default maxWidth={1440}>
            <Styles.Wrapper>{financeDisclaimerLabel}</Styles.Wrapper>
        </Container.default>
    );
};

export default PageFinanceDisclaimer;
